export const statisticTypeEnumById = {
  1: 'gameType',
  2: 'table',
  3: 'dealer'
};
export const statisticTypeEnumByKey = {
  gameType: 1,
  table: 2,
  dealer: 3
};

export const alertTypes = {
  MarginWinners: 1,
  Winners: 2,
  StraightUpWinners: 3,
  OppositeBetting: 4,
  SuspiciousTips: 5,
  gameWinners: 6,
  advantagePlay: 8,
  robotPlay: 9,
  sideBets: 10,
  dragonTigerSideBets: 11
};

export const lcrmtNotificationSettingsUrl = {
  7: 'daily-alerts/opposite-betting',
  8: 'daily-alerts/suspicious-tips',
  9: 'hourly-alerts/margin-winners',
  10: 'hourly-alerts/winners',
  11: 'hourly-alerts/straight-up-winners',
  15: 'hourly-alerts/game-winners',
  16: 'daily-alerts/advantage-play/blackjack-main-bets',
  21: 'daily-alerts/advantage-play/blackjack-side-bets',
  38: 'game-integrity-alerts/traffic-metric'
};

export const grmtNotificationSettingsUrl = {
  23: 'player-alerts/general/player-sports',
  24: 'player-alerts/general/player-casino',
  25: 'player-alerts/general/player-payments',
  26: 'player-alerts/general/player-general',
  29: 'player-alerts/single/single-sports',
  30: 'player-alerts/single/single-casino',
  31: 'player-alerts/single/single-payments',
  27: 'game-alerts/sports',
  28: 'game-alerts/casino',
  32: 'partner-alerts'
};

export const crmtNotificationSettingsUrl = {
  33: 'game-anomalies/suspicious-money-turnover',
  34: 'game-anomalies/suspicious-game-activity',
  35: 'cumulative-loss',
  36: 'player-anomalies/player-negative-ngr',
  37: 'player-anomalies/general'
};
